import Tags from "bootstrap5-tags/tags";

const initializeTagsinput = () => {
  Tags.init(".js-tags-input");
};

export default initializeTagsinput;
